'use client';
import React from 'react';
import { useGlobalStore } from '@/store/useGlobalStore';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const iconMap = {
  success: <CheckCircle size={16} className="text-positive flex-shrink-0" />,
  error: <XCircle size={16} className="text-negative flex-shrink-0" />,
  warning: <AlertTriangle size={16} className="text-warning flex-shrink-0" />,
  info: <Info size={16} className="text-info flex-shrink-0" />,
};

const bgMap = {
  success: 'var(--positive-bg)',
  error: 'var(--negative-bg)',
  warning: 'var(--warning-bg)',
  info: 'var(--info-bg)',
};

export default function ToastManager() {
  const { toasts, removeToast } = useGlobalStore();

  return (
    <div className="fixed top-16 left-0 right-0 z-[100] flex flex-col items-center gap-2 px-4 pointer-events-none">
      <AnimatePresence>
        {toasts?.map((toast) => (
          <motion.div
            key={toast?.id}
            initial={{ y: -20, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -10, opacity: 0, scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
            className="w-full max-w-sm pointer-events-auto"
          >
            <div
              className="flex items-center gap-3 px-4 py-3 rounded-2xl shadow-xl"
              style={{
                background: bgMap?.[toast?.type],
                border: '1px solid var(--border)',
                backdropFilter: 'blur(12px)',
              }}
            >
              {iconMap?.[toast?.type]}
              <p className="text-sm font-medium text-foreground flex-1">{toast?.message}</p>
              <button
                onClick={() => removeToast(toast?.id)}
                className="p-1 rounded-lg transition-all active:scale-95"
              >
                <X size={14} className="text-muted-foreground" />
              </button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}